<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>

<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			Case Details
			<span class="float-end text-light me-3">
				Case-Id:
				<strong>
					{{caseDetails?.case_id}}
				</strong>
			</span>
			<span class="float-end text-light me-3">
				<strong>
					<fa-icon [icon]="['fas',caseDetails?.status==2?'lock':'lock-open']"
						[matTooltip]="caseDetails?.case_status">
					</fa-icon>
				</strong>
			</span>
		</h5>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Name&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.f_name}} {{caseDetails?.l_name}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>DOB&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.dob || "___"}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Rank&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.rank_name || "___"}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Vessel&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.vessel || "___"}}
			</div>
		</div>
	</div>
</div>
<div class="card">
	<div class="card-body">
		<ul class="nav nav-tabs nav-tabs-bordered">
			<li class="nav-item" role="button" (click)="setActiveTab(0)">
				<a class="nav-link" [ngClass]="getTabClass(0)" data-bs-toggle="tab" role="tab"
					aria-controls="ex1-tabs-1" aria-selected="true">
					Prescription
				</a>
			</li>
			<li class="nav-item" role="button" (click)="setActiveTab(1)">
				<a class="nav-link" [ngClass]="getTabClass(1)" data-bs-toggle="tab" role="tab"
					aria-controls="ex1-tabs-1" aria-selected="true">
					Lab Tests
				</a>
			</li>
		</ul>
		<div class="tab-content">
			<div id="tab0" [ngClass]="getTabPaneClass(0)">
				@if(showMedHistory){
				<div class="row mb-2">
					<div class="col">
						<h3 class="fw-bold">
							Medicines
							<button class="btn btn-primary btn-xs ms-1" (click)="medSection()">
								<fa-icon [icon]="['fas',medArray.length?'edit':'plus']"></fa-icon>
								{{medArray.length?'Edit':'Add'}}
							</button>
						</h3>
						<p *ngIf="medArray.length == 0">No medicines added.</p>
					</div>
					<div class="col">
						<button *ngIf="medArray.length" class="btn btn-primary btn-xs float-end"
							(click)="copyMedicinesToClipBoard(1)">
							Copy to clipboard
						</button>
					</div>
				</div>
				<div class="row mb-2" *ngIf="printPrescArray.length > 0">
					<div class="col-sm-7">
						<div class="form-floating">
							<textarea [(ngModel)]="prescriptionPara.chief_complaint" class="form-control"
								placeholder=""></textarea>
							<label>Chief Complaint</label>
						</div>
					</div>
					<div class="col-sm-5">
						<ng-select [items]="doctorList" bindLabel="name" placeholder="Doctor*"
							[(ngModel)]="prescriptionPara.prescDoctor" appearance="outline" plac>
						</ng-select>
						<button class="btn btn-success btn-xs float-end mt-2" (click)="loadMedsPdf()"
							[disabled]="prescPdfLoader">
							<fa-icon [icon]="['fas','spinner']" [animation]="'spin'" *ngIf="prescPdfLoader"></fa-icon>
							Download Prescription
						</button>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col">
						<table class="table table-bordered" *ngIf="medArray.length > 0">
							<thead>
								<tr>
									<th>
										Select
										<button class="btn btn-xs btn-primary ms-1" *ngIf="printPrescArray.length > 0"
											matTooltip="Clear" (click)="clearPrescArray()">
											<fa-icon [icon]="['fas','sync-alt']"></fa-icon>
										</button>
									</th>
									<th>Date</th>
									<th>Name</th>
									<th>Dosage</th>
									<th>Frequency</th>
									<th>Meals</th>
									<th>No. Of Days</th>
									<th>Status</th>
									<th>Notes</th>
									<th>Added By</th>
									<th>Updated By</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let field of medArray; let i = index">
									<td>
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.isChecked"
											(change)="checkMedicine(field)"></mat-checkbox>
									</td>
									<td>
										{{field.medDate | date }}
									</td>
									<td>
										{{field.name}}
									</td>
									<td>
										{{field.qty}}
									</td>
									<td>
										{{getFrequencyText(field)}}
									</td>
									<td>
										{{field.meals}}
									</td>
									<td>
										{{field.noOfDays}}
									</td>
									<td>
										{{field.status}}
									</td>
									<td>
										{{field.notes}}
									</td>
									<td>
										{{field.addedBy}}
									</td>
									<td>
										{{field.updatedBy}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				}@else {
				<div class="row">
					<div class="col">
						<table class="table table-bordered med-table">
							<thead>
								<tr>
									<th style="width: 10% !important;"><span style="color: #b40a09;">*&nbsp;</span> Date
									</th>
									<th style="width: 25% !important;"><span style="color: #b40a09;">*&nbsp;</span>
										Medicine
									</th>
									<th style="width: 10% !important;">Dosage</th>
									<th style="width: 10% !important;">Frequency
									</th>
									<th style="width: 10% !important;">Meals</th>
									<th style="width: 10% !important;">No. Of Days
									</th>
									<th style="width: 10% !important;">Notes</th>
									<th style="width: 10% !important;">Status</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let field of medArray; let i = index">
									<td>
										<input class="form-control" placeholder="" [(ngModel)]="field.medDate"
											ngbDatepicker #medDate="ngbDatepicker" [minDate]="minDate"
											[container]="'body'" (click)="medDate.toggle()" />
									</td>
									<td>
										<ng-container *ngIf="field.isSaved">{{field.name}}</ng-container>
										<ng-container *ngIf="!field.isSaved">
											<div class="ng-autocomplete">
												<ng-autocomplete [(ngModel)]="field.name" [data]="medicineMaster"
													placeholder="Medicine*" historyIdentifier="medicineMaster"
													[itemTemplate]="medItemTemplate"
													[notFoundTemplate]="medNotFoundTemplate"
													(inputChanged)="onMedInputChanged($event,i)" [debounceTime]="500"
													[minQueryLength]="1" [isLoading]="medLoading==i"
													placeholder="Search medicines..."></ng-autocomplete>
												<ng-template #medItemTemplate let-item>
													<a [innerHTML]="item"></a>
												</ng-template>
												<ng-template #medNotFoundTemplate let-notFound>
													<div [innerHTML]="notFound"></div>
												</ng-template>
											</div>
										</ng-container>
									</td>
									<td>
										<input class="form-control" [(ngModel)]="field.qty" placeholder="">
									</td>
									<td>
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.morning">
											Morning
										</mat-checkbox>
										<br />
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.afternoon">
											Afternoon
										</mat-checkbox>
										<br />
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.evening">
											Evening
										</mat-checkbox>
										<br />
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.sos">
											SOS
										</mat-checkbox>
									</td>
									<td>
										<select class="form-select" [(ngModel)]="field.meals">
											@for (item of mealsList; track $index) {
											<option [value]="item">{{item}}</option>
											}
										</select>
									</td>
									<td>
										<input class="form-control" type="number" [(ngModel)]="field.noOfDays"
											placeholder="">
									</td>
									<td>
										<input class="form-control" [(ngModel)]="field.notes" placeholder="">
									</td>
									<td>
										{{field.status}}
									</td>
									<td>
										<button class="btn btn-danger btn-xs" matTooltip="Remove" type="button"
											(click)="removeMedicine(i)">
											<fa-icon [icon]="['fas','trash-alt']"></fa-icon>
										</button>
										<button *ngIf="field.status=='Completed'" class="btn btn-primary btn-xs ms-1"
											matTooltip="Re-Prescribe" type="button" (click)="rePrescribeMedicine(i)">
											<fa-icon [icon]="['fas','redo']"></fa-icon>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col text-center">
						<button class="btn btn-info btn-sm" type="button" (click)="AddNewMedicine()">
							Add
						</button>
					</div>
				</div>
				<hr style="margin-top: 10px;margin-bottom: 10px;border: 0;border-top: 1px solid #8394a97d;" />
				<div class="row mb-2">
					<div class="col">
						<button [disabled]="saveMedLoader" class="btn btn-success btn-sm" (click)="saveMedicines()">
							<fa-icon *ngIf="saveMedLoader" [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
							Save
						</button>
						<button class="btn btn-light btn-sm ms-1" (click)="medSection();clearPrescArray();">
							Cancel
						</button>
					</div>
				</div>
				}
				<div class="row mb-2">
					<div class="col">
						<h3 class="fw-bold">Prescription History</h3>
						<table class="table table-bordered" *ngIf="casePrescPdfList.length">
							<thead>
								<tr>
									<th>Date</th>
									<th>Name</th>
									<th>Prescribe By</th>
									<th>Download</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let presc of casePrescPdfList; let i = index">
									<td>{{presc.date}}</td>
									<td>{{getFileName(presc.report_name)}}</td>
									<td>{{presc.prescribe_by}}</td>
									<td>
										<a download href="{{presc.url}}" target="_blank" class="btn btn-xs btn-primary"
											matTooltip="Download Pdf">
											<fa-icon [icon]="['fas','cloud-download-alt']"></fa-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!casePrescPdfList.length">History Not Found</p>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col">
						<div id="medicineTempTableContainerForCopy1"></div>
					</div>
				</div>
			</div>
			<div id="tab1" [ngClass]="getTabPaneClass(1)">
				@if(showTestHistory){
				<div class="row mb-2">
					<div class="col">
						<h3 class="fw-bold">
							Lab Tests
							<button class="btn btn-primary btn-xs ms-1" (click)="testSection()">
								<fa-icon [icon]="['fas',testArray.length?'edit':'plus']"></fa-icon>
								{{testArray.length?'Edit':'Add'}}
							</button>
						</h3>
						<p *ngIf="testArray.length == 0">No tests added.</p>
					</div>
					<div class="col">
						<button *ngIf="testArray.length" class="btn btn-primary btn-xs float-end"
							(click)="copyTestsToClipBoard(1)">
							Copy to clipboard
						</button>
					</div>
				</div>
				<div class="row mb-2" *ngIf="printTestArray.length > 0">
					<div class="col-sm-7">
						<div class="form-floating">
							<textarea [(ngModel)]="testPara.chief_complaint" class="form-control"
								placeholder=""></textarea>
							<label>Chief Complaint</label>
						</div>
					</div>
					<div class="col-sm-5">
						<ng-select [items]="doctorList" bindLabel="name" placeholder="Doctor*"
							[(ngModel)]="testPara.prescDoctor" appearance="outline" plac>
						</ng-select>
						<button class="btn btn-success btn-xs float-end mt-2" (click)="loadTestsPdf()"
							[disabled]="testPdfLoader">
							<fa-icon [icon]="['fas','spinner']" [animation]="'spin'" *ngIf="testPdfLoader"></fa-icon>
							Download Prescription
						</button>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col">
						<table class="table table-bordered" *ngIf="testArray.length > 0">
							<thead>
								<tr>
									<th>
										Select
										<button class="btn btn-xs btn-primary ms-1" *ngIf="printTestArray.length > 0"
											matTooltip="Clear" (click)="clearTestArray()">
											<fa-icon [icon]="['fas','sync-alt']"></fa-icon>
										</button>
									</th>
									<th>Date</th>
									<th>Lab Test</th>
									<th>Notes</th>
									<th>Added By</th>
									<th>Updated By</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let field of testArray; let i = index">
									<td>
										<mat-checkbox [color]="'primary'" [(ngModel)]="field.isChecked"
											(change)="checkTest(field)"></mat-checkbox>
									</td>
									<td>
										{{field.date | date }}
									</td>
									<td>
										{{field.name}}
									</td>
									<td>
										{{field.notes}}
									</td>
									<td>
										{{field.addedBy}}
									</td>
									<td>
										{{field.updatedBy}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				}@else {
				<div class="row">
					<div class="col">
						<table class="table table-bordered med-table">
							<thead>
								<tr>
									<th style="width: 10% !important;">
										<span style="color: #b40a09;">*&nbsp;</span>
										Date
									</th>
									<th style="width: 25% !important;">
										<span style="color: #b40a09;">*&nbsp;</span>
										Lab Test
									</th>
									<th style="width: 60% !important;">Notes</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let field of testArray; let i = index">
									<td>
										<input class="form-control" placeholder="" [(ngModel)]="field.date"
											ngbDatepicker #date="ngbDatepicker" [minDate]="minDate" [container]="'body'"
											(click)="date.toggle()" />
									</td>
									<td>
										<ng-container *ngIf="field.isSaved">{{field.name}}</ng-container>
										<ng-container *ngIf="!field.isSaved">
											<div class="ng-autocomplete">
												<ng-autocomplete [(ngModel)]="field.name" [data]="testMaster"
													placeholder="Lab Test*" historyIdentifier="testMaster"
													[itemTemplate]="testItemTemplate"
													[notFoundTemplate]="testNotFoundTemplate"
													(inputChanged)="onTestInputChanged($event,i)" [debounceTime]="500"
													[minQueryLength]="1" [isLoading]="testLoading==i"
													placeholder="Search tests..."></ng-autocomplete>
												<ng-template #testItemTemplate let-item>
													<a [innerHTML]="item"></a>
												</ng-template>
												<ng-template #testNotFoundTemplate let-notFound>
													<div [innerHTML]="notFound"></div>
												</ng-template>
											</div>
										</ng-container>
									</td>
									<td>
										<input class="form-control" [(ngModel)]="field.notes" placeholder="">
									</td>
									<td>
										<button class="btn btn-danger btn-xs" matTooltip="Remove" type="button"
											(click)="removeTest(i)">
											<fa-icon [icon]="['fas','trash-alt']"></fa-icon>
										</button>
										<!-- <button class="btn btn-primary btn-xs ms-1" matTooltip="Re-Prescribe"
											type="button" (click)="rePrescribeTest(i)">
											<fa-icon [icon]="['fas','redo']"></fa-icon>
										</button> -->
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col text-center">
						<button class="btn btn-info btn-sm" type="button" (click)="AddNewTest()">
							Add
						</button>
					</div>
				</div>
				<hr style="margin-top: 10px;margin-bottom: 10px;border: 0;border-top: 1px solid #8394a97d;" />
				<div class="row mb-2">
					<div class="col">
						<button [disabled]="saveTestLoader" class="btn btn-success btn-sm" (click)="saveTests()">
							<fa-icon *ngIf="saveTestLoader" [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
							Save
						</button>
						<button class="btn btn-light btn-sm ms-1" (click)="testSection();clearTestArray();">
							Cancel
						</button>
					</div>
				</div>
				}
				<div class="row mb-2">
					<div class="col">
						<h3 class="fw-bold">Prescription History</h3>
						<table class="table table-bordered" *ngIf="caseTestPdfList.length">
							<thead>
								<tr>
									<th>Date</th>
									<th>Name</th>
									<th>Prescribe By</th>
									<th>Download</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let presc of caseTestPdfList; let i = index">
									<td>{{presc.date}}</td>
									<td>{{getFileName(presc.report_name)}}</td>
									<td>{{presc.prescribe_by}}</td>
									<td>
										<a download href="{{presc.url}}" target="_blank" class="btn btn-xs btn-primary"
											matTooltip="Download Pdf">
											<fa-icon [icon]="['fas','cloud-download-alt']"></fa-icon>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<p *ngIf="!caseTestPdfList.length">History Not Found</p>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col">
						<div id="testTempTableContainerForCopy1"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>